import { get, post } from '@/service/api'

// 抽奖接口
export function drawLottery(params = {}) {
  return post('/hyyj/lottery/draw', params)
}

// 排名接口
export function getRanking(params = {}) {
  return get('/hyyj/ranking', params)
}

// 抽奖记录接口
export function getLotteryRecord(params = {}) {
  return get('/hyyj/lottery/record', params)
}
